import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import Scene from "./Scene/Scene";
import { CANVAS_CONFIG } from "../constants";

export default function Canvas3D() {
  const { CAMERA, LIGHTS, ORBIT_CONTROLS } = CANVAS_CONFIG;

  return (
    <Canvas shadows camera={{ position: CAMERA.POSITION, fov: CAMERA.FOV }}>
      <ambientLight intensity={LIGHTS.AMBIENT.intensity} />
      <directionalLight
        position={LIGHTS.DIRECTIONAL_1.position}
        intensity={LIGHTS.DIRECTIONAL_1.intensity}
        castShadow={LIGHTS.DIRECTIONAL_1.castShadow}
      />
      <directionalLight
        position={LIGHTS.DIRECTIONAL_2.position}
        intensity={LIGHTS.DIRECTIONAL_2.intensity}
        color={LIGHTS.DIRECTIONAL_2.color}
      />
      <pointLight
        position={LIGHTS.POINT.position}
        intensity={LIGHTS.POINT.intensity}
        color={LIGHTS.POINT.color}
      />
      <Suspense fallback={null}>
        <Scene />
      </Suspense>
      <OrbitControls {...ORBIT_CONTROLS} />
    </Canvas>
  );
}

